import React from "react";

const OnboardingForm = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-2">
      <div className="max-w-7xl w-full bg-white shadow-lg rounded-2xl p-2">       
        <div className="w-full">
          <iframe
            aria-label="Zafflo Onboarding Form"
            frameBorder="0"
            allow="camera;"
            style={{ height: "2160px", width: "100%", border: "none" }}
            src="https://forms.zohopublic.in/mrarvindpingegm1/form/ZaffloOnboardingForm/formperma/d1ck_W0mDWDjygcceCSscUPRDpync8eFLz_XfjIakYU?zf_enablecamera=true"
            title="Zafflo Onboarding Form"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default OnboardingForm;
